import actions from '../../actionTypes';

export default (status) => {
  return {
    type: actions.RESET_PASSWORD_COMPLETED,
    status
  };
};


// WEBPACK FOOTER //
// ./src/reducers/auth/actions/resetPasswordCompleted.js